export const featuredEpisode = {
  id: 1,
  number: 1,
  title: "The Age of AI: Growth, Promise, and the Need for Wisdom",
  description:
    "AI is growing at 36.6% annually and could add $15.7 trillion to the global economy by 2030. But what does that mean for everyday people, workers, and families? In this first episode, we break down where AI stands today, how it\u2019s affecting jobs and opportunity, and why wisdom \u2014 not fear or hype \u2014 is the right response.",
  category: "Foundations",
  duration: "15 min",
  date: "March 30, 2026",
  comingSoon: false,
  spotifyUrl: "https://podcasters.spotify.com/pod/show/rich/episodes/The-Age-of-AI-Growth--Promise--and-the-Need-for-Wisdom-e3h58h6",
  appleUrl: "#",
  googleUrl: "#",
  amazonUrl: "#",
  audioUrl: "https://anchor.fm/s/1109e116c/podcast/play/117661670/https%3A%2F%2Fd3ctxlq1ktw2nl.cloudfront.net%2Fstaging%2F2026-2-30%2Fe723fc7a-87db-ffbe-fb54-43738ec4290d.mp3",
};

export const comingSoonEpisodes = [
  {
    id: 2,
    number: 2,
    teaserTitle: "AI at Work",
    teaserTheme: "Work & Career",
    icon: "ri-briefcase-line",
  },
  {
    id: 3,
    number: 3,
    teaserTitle: "Faith & The Machine",
    teaserTheme: "Faith & Values",
    icon: "ri-hand-heart-line",
  },
  {
    id: 4,
    number: 4,
    teaserTitle: "Small Business & AI",
    teaserTheme: "Business",
    icon: "ri-store-2-line",
  },
  {
    id: 5,
    number: 5,
    teaserTitle: "Raising Kids in an AI World",
    teaserTheme: "Family",
    icon: "ri-home-heart-line",
  },
  {
    id: 6,
    number: 6,
    teaserTitle: "Tools You Can Actually Use",
    teaserTheme: "Tools & Tech",
    icon: "ri-tools-line",
  },
  {
    id: 7,
    number: 7,
    teaserTitle: "AI & Healthcare",
    teaserTheme: "Health",
    icon: "ri-heart-pulse-line",
  },
];

export const testimonials = [
  {
    id: 1,
    quote:
      "This podcast makes AI feel approachable and human. I used to be scared of all of it \u2014 now I feel like I can actually participate in the conversation.",
    name: "Sarah Mitchell",
    role: "Small Business Owner, Ohio",
    platform: "Apple Podcasts",
  },
  {
    id: 2,
    quote:
      "As a pastor, I\u2019ve been trying to figure out how to talk to my congregation about AI. This podcast gave me the language and the confidence to do that.",
    name: "Pastor James Okafor",
    role: "Community Pastor, Atlanta",
    platform: "Spotify",
  },
  {
    id: 3,
    quote:
      "I\u2019m a nurse, not a tech person. But after listening to this show, I feel like I understand what\u2019s coming in healthcare \u2014 and how to advocate for my patients.",
    name: "Maria Delgado",
    role: "Registered Nurse, Texas",
    platform: "Google Podcasts",
  },
];
